import { useFormContext, useFieldArray } from 'react-hook-form';
import { BasicSelectField } from 'lib/iterable-hook-form';
import { ALIGNMENT } from 'ui/selects';
import { Delete16, Add16 } from 'ui/icons';
import { APPLICATIONS_FORM_FIELD_PATHS } from 'modules/sendingPlatforms/contexts/DestinationFormProvider';
import { BUTTON_VARIANTS, GhostButton } from 'ui/button';
import { ConnectedInputField } from '../../Shared/ConnectedInputField';
import {
  BasicSelectFieldFullWidth,
  FormFieldNoMargin,
  Columns,
  Container,
  GreyContainer,
  DeleteButton,
} from './ApplicationsFormSection.styled';

const { MOBILE_APPS, NAME, PACKAGE_NAME, PLATFORM } = APPLICATIONS_FORM_FIELD_PATHS;

const platformOptions = [
  { id: 'Android', label: 'Android', value: 'android' },
  { id: 'iOS', label: 'iOS', value: 'ios' },
];

export const ApplicationsFormSection = () => {
  const { control } = useFormContext();
  const { fields, append, remove } = useFieldArray({
    control,
    name: MOBILE_APPS,
  });

  const [first, ...rest] = fields;

  return (
    <Container>
      <GreyContainer>
        <Columns key={first?.id} hideDelete={!rest.length}>
          <ConnectedInputField labelText="Application name" name={`${MOBILE_APPS}.0.${NAME}`} />
          <ConnectedInputField
            formFieldProps={{ style: { marginTop: 0 } }}
            labelText="Package name"
            name={`${MOBILE_APPS}.0.${PACKAGE_NAME}`}
          />
          <FormFieldNoMargin inputId="destination-form_platform" labelText="Platform">
            <BasicSelectFieldFullWidth
              id="destination-form_platform"
              name={`${MOBILE_APPS}.0.${PLATFORM}`}
              horizontalAlignment={ALIGNMENT.RIGHT}
              options={platformOptions}
            />
          </FormFieldNoMargin>
          {!!rest.length && (
            <DeleteButton
              variant={BUTTON_VARIANTS.GHOST}
              onClick={() => {
                remove(0);
              }}
              style={{ marginTop: 33 }}
            >
              <Delete16 />
            </DeleteButton>
          )}
        </Columns>
        {rest.map((field: any, idx: number) => (
          <Columns key={field.id}>
            <ConnectedInputField name={`${MOBILE_APPS}.${idx + 1}.${NAME}`} />
            <ConnectedInputField
              name={`${MOBILE_APPS}.${idx + 1}.${PACKAGE_NAME}`}
              formFieldProps={{ style: { marginTop: 0 } }}
            />
            <BasicSelectField
              horizontalAlignment={ALIGNMENT.RIGHT}
              options={platformOptions}
              name={`${MOBILE_APPS}.${idx + 1}.${PLATFORM}`}
            />
            <DeleteButton
              variant={BUTTON_VARIANTS.GHOST}
              onClick={() => {
                remove(idx + 1);
              }}
            >
              <Delete16 />
            </DeleteButton>
          </Columns>
        ))}
        <GhostButton
          onClick={() => {
            append({
              [NAME]: '',
              [PACKAGE_NAME]: '',
              [PLATFORM]: 'android',
            });
          }}
        >
          <Add16 />
          Add application
        </GhostButton>
      </GreyContainer>
    </Container>
  );
};
